"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var context = /*#__PURE__*/_react.default.createContext({
  animating: false,
  atBottom: true,
  atEnd: true,
  atTop: true,
  mode: 'bottom',
  sticky: true
});

context.displayName = 'ScrollToBottomStateContext';
var _default = context;
exports.default = _default;